let currentSubpageMenuItem;

const toggleSubpageMenu = (button) => {

    let subpageMenu = button.nextElementSibling;

    if ("true" === button.getAttribute("aria-expanded")) {
        button.setAttribute("aria-expanded", false);
        subpageMenu.classList.toggle("subpageMenu--expanded");
        subpageMenu.setAttribute("aria-expanded", false);
        currentSubpageMenuItem = false;
    } else {
        button.setAttribute("aria-expanded", true);
        subpageMenu.classList.toggle("subpageMenu--expanded");
        subpageMenu.setAttribute("aria-expanded", true);
        currentSubpageMenuItem = button;
    }
};

const closePrevSubpageMenuBtn = ({ target }) => {
    toggleSubpageMenu(target);
};

const closeOpenSubpageMenu = ({ target }) => {
    if (currentSubpageMenuItem && !target.closest("#subpageNavigation")) {
        toggleSubpageMenu(currentSubpageMenuItem);
    }
};

const closeSubpageMenuOnEscKey = ({ keyCode, target }) => {
    if (27 === keyCode) {
        // we're in a submenu item
        if (null !== target.closest('ul[aria-expanded="true"]')) {
            currentSubpageMenuItem.focus();
            toggleSubpageMenu(currentSubpageMenuItem);

            // we're on a parent item
        } else if ("true" === target.getAttribute("aria-expanded")) {
            toggleSubpageMenu(currentSubpageMenuItem);
        }
    }
};

export const eventListenerSubpageMenuBtn = () => {
    var subpageMenuBtnsArray = document.getElementsByClassName(
        "inner-nav__expand-button"
    );
    Array.from(subpageMenuBtnsArray).forEach((element) => {
        element.addEventListener("click", (e) => closePrevSubpageMenuBtn(e));

    });

    var subpageMenu = document.getElementById("subpageNavigation");
    subpageMenu.addEventListener("keyup", (e) => closeSubpageMenuOnEscKey(e));

    document.addEventListener("click", (e) => closeOpenSubpageMenu(e));
};
export const initSubpageMenu = () => {
    var subpageMenuBtnsArray = document.getElementsByClassName(
        "inner-nav__expand-button"
    );
    Array.from(subpageMenuBtnsArray).forEach((element) => {
        let subpageMenu = element.nextElementSibling;
        //let activeLink = element.previousElementSibling;
        
        if ("true" === element.getAttribute("aria-expanded")) {
            element.setAttribute("aria-expanded", true);
            //activeLink.classList.toggle("active");
            subpageMenu.classList.toggle("subpageMenu--expanded");
            subpageMenu.setAttribute("aria-expanded", true);
        }
    });
};
